import { defDatetimeRangeFilter } from "helpers/date";
import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as source from "sources/books/notificationQueues";
import List from "./list";
import Show from "./show";

export default class NotificationQueues extends Component {
    componentWillUnmount() {
        this.props.resetPaginationPage("notification-queues", defDatetimeRangeFilter("sentAt"));
    }

    render() {
        const { match, location, history } = this.props;
        const rootUrl = `${match.path}/list`;
        const back = () => history.push(rootUrl);
        return (
            <div className="page-content">
                <Switch location={location}>
                    <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                    <Route
                        path={rootUrl}
                        render={() => (
                            <>
                                <List {...this.props} isTable transition="full" title="Логи уведомлений" nofilter />
                                <Route
                                    path={`${rootUrl}/:id`}
                                    render={(rest) => <Show {...rest} source={source} back={back} />}
                                />
                            </>
                        )}
                    />
                </Switch>
            </div>
        );
    }
}
